import { apiClient } from "helpers/api_helper";

export const getReturnDeductionDetailsById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnDeduction/GetReturnDeductionDetailsById?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createReturnDeduction= async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/ReturnDeduction/InsertReturnDeduction', data);
        return response;
    } catch(error: any) {
        throw new Error(error.message);
    }
};

export const updateReturnDeduction= async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/ReturnDeduction/UpdateReturnDeduction', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllReturnDeduction = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnDeduction/GetAllReturnDeduction`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteReturnDeduction = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/ReturnDeduction/DeleteReturnDeduction?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};